export const SYNC_NOTIFICATIONS_SETTING = '@@notificationsSettings/sync'

export const SET_NOTIFICATIONS_SETTING = '@@notificationsSettings/set'

export const UPDATE_NOTIFICATIONS_SETTING = '@@notificationsSettings/update'
